import { ReactNode } from 'react';
import { Box, Stack, Typography } from '@mui/material';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}

export const PageHeader = ({ title, subtitle, actions }: PageHeaderProps) => (
  <Stack
    direction={{ xs: 'column', sm: 'row' }}
    justifyContent="space-between"
    alignItems={{ xs: 'stretch', sm: 'center' }}
    spacing={2}
    sx={{ mb: 3, minWidth: 0 }}
  >
    <Box sx={{ minWidth: 0 }}>
      <Typography variant="h4" fontWeight={700} sx={{ wordBreak: 'break-word' }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ wordBreak: 'break-word' }}>
          {subtitle}
        </Typography>
      )}
    </Box>
    {actions && (
      <Box sx={{ minWidth: 0, width: { xs: '100%', sm: 'auto' } }}>{actions}</Box>
    )}
  </Stack>
);
